import {AuditService} from "../PA.Core/Security/AuditService";
import {UserGroupBO} from "./UserGroupBO";
import {AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {esWB_Customer, esWB_Domain_Item, esWB_SalesArea, esWB_User} from "../PA.Core/PAdbSchema";
import * as _ from "lodash";
import { WB_UserGroupSalesAreaRow} from "../PA.Core/PAdbSchemaRows";

export class UserGroupBOAudit {

    // Audit Log Service for User Group

    static async UserGroupAuditBO(UserGroupBO: UserGroupBO): Promise<AuditService> {
        const self = UserGroupBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("UserGroup", self.drWB_UserGroup.cif.WB_USRGRP_ID)
        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        //Main User group
        const userGroupParams: IAuditField [] = [

            {fieldName: "USRGRP_ID", realName: "ID", bAllMsg: true},
            {fieldName: "USRGRP_NAME", realName: "Name",bAllMsg: true},
            {fieldName: "TREE_PATH", realName: "Tree Path"},
            {fieldName: "RENDER_OPTIONS", realName: "Render Options"},
            {fieldName: "COMMENTS", realName: "Comments"},
        ]

        //Members
        const membersParams: IAuditField [] = [
            {
                fieldName: "WB_AUTHUSR_ID",
                realName: `Member`,
                fkMapper: esWB_User,
                fkMapperNameField:"AUTHUSR_NAME",
                fkMapperIdField:"AUTHUSR_ID",
                bAllMsg: true
            },
        ]
        //USerGroupCust Relation
        const userGroupCustRelParams: IAuditField [] = [
            {
                fieldName: "WB_CUST_ID",
                realName: `Customer`,
                fkMapper:esWB_Customer,
                fkMapperNameField: "CUSTOMER_NAME",
                fkMapperIdField: "CUSTOMER_ID",
                bAllMsg: true
            },
        ]
        //User Roles
            const userRoleParams: IAuditField [] = [
            {fieldName: "WB_DOMITEM_ID", realName: `User Roles`,           fkMapper: esWB_Domain_Item, fkMapperNameField: "DOMAIN_ITEM_NAME", bAllMsg: true},
            {fieldName: "WB_CUST_ID",    realName: "Customer Restriction", fkMapper: esWB_Customer,    fkMapperNameField: "CUSTOMER_NAME", fkMapperIdField: "CUSTOMER_ID", bAllMsg: true }
        ]

        // Sales Area
        const userGroupSalesArea: IAuditField[]= [
            {fieldName: "WB_SALESAREA_ID",
                fkMapper: esWB_SalesArea,
                fkMapperNameField: "SALESAREA_NAME",
                fkMapperIdField: "SALESAREA_ID",
                bAllMsg: true,
                realName: "Sales Area", },

        ]
        //Main object logging
        await AuditUtils.logRecord(auditService, self.drWB_UserGroup, userGroupParams, {
            objectName: 'User Group',
            deletedKeys: deleteKeys
        })

        //Members
        for (let aUsrGrpUsrRelRow of self.drWB_UserGroup.WB_UserGroupUserRows) {
            await AuditUtils.logRecord(auditService, aUsrGrpUsrRelRow, membersParams, {
                objectName: 'Member',
                deletedKeys: deleteKeys
            })

        }

        //Customer row
        for (let aUsrGrpCustRelRow of self.drWB_UserGroup.WB_UserGroupCustomerRows) {
            await AuditUtils.logRecord(auditService, aUsrGrpCustRelRow, userGroupCustRelParams, {
                objectName: 'Customer',
                deletedKeys: deleteKeys
            })
        }

        //User Roles
        for (let aUsrGrpRoleRelRow of self.drWB_UserGroup.WB_UserGroupRoleRows) {
            await AuditUtils.logRecord(auditService, aUsrGrpRoleRelRow, userRoleParams, {
                objectName: 'User Group Role',
                deletedKeys: deleteKeys
            })
        }

        // Sales Area
        _.forEach(self.drWB_UserGroup.WB_UserGroupSalesAreaRows, async (aUsrGrpSalesAreaRow: WB_UserGroupSalesAreaRow) => {
            await AuditUtils.logRecord(auditService, aUsrGrpSalesAreaRow, userGroupSalesArea, {objectName: 'Sales Area', deletedKeys: deleteKeys})
        })
        return auditService;
    }

}